import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { RiderEmailComponent } from './rider-email.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActionTooltipModule } from '../directives/action-tooltip';

@NgModule({
  declarations: [RiderEmailComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ActionTooltipModule
  ],
  exports: [RiderEmailComponent]
})
export class RiderEmailModule { }
